(() => {
  const init = root => {
    if (root.dataset.tcReady) return;
    root.dataset.tcReady = 'true';
    root.querySelectorAll('.te-mobile-nav a').forEach(link => link.addEventListener('click', () => link.closest('details').removeAttribute('open')));
    root.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const menu = root.querySelector('.te-mobile-nav[open]');
      if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
    });
  };
  const scan = scope => {
    const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewId) scope.querySelectorAll('a[href]').forEach(link => {
      const target = new URL(link.href, window.location.href);
      if (target.origin === window.location.origin && target.searchParams.has('view')) {
        target.searchParams.set('preview_theme_id', previewId);
        link.href = target.href;
      }
    });
    if (scope.matches?.('[data-tys-concepts]')) init(scope);
    scope.querySelectorAll('[data-tys-concepts]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
